module.exports = __webpack_public_path__ + "img/forehead.a60120e6.svg";